import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

import PersonIcon from '@mui/icons-material/Person'
import BusinessIcon from '@mui/icons-material/Business'

import { foiStatuses } from '../../util/foiConsts'
import { BoldFormTitle, MedBodyText, BoldMedBodyText } from '../styles/Text'
import { Wrapper, AllFields, CenterFields, FirstItem, Item, MedItem, SmallItem, LastItem, AssignedTo } from '../styles/FOITableStyles'
import FOIStatus from '../foiResponse/FOIStatus'
import Keywords from '../foiResponse/Keywords'
import AssignedUserChip from '../common/AssignedUserChip'

function FOIRow({ foi, isCompleted = false }) {
  const { secondaryId, applicantType, keywords, requestorName, createdAt, closedDate, finalDate, status, assignedTo } = foi

  return (
    <Wrapper>
      <AllFields>
        {!isCompleted && (
          <AssignedTo>
            {assignedTo && <AssignedUserChip firstName={assignedTo.firstName} lastName={assignedTo.lastName} color={assignedTo.chipColor} isShort />}
          </AssignedTo>
        )}
        <FirstItem gap="10px">
          {applicantType === 'COMMERCIAL' ? <BusinessIcon /> : <PersonIcon />}
          <BoldFormTitle>{secondaryId}</BoldFormTitle>
        </FirstItem>
        <CenterFields>
          <Item size={isCompleted ? 'small' : 'large'}>
            <Keywords keywords={keywords} />
          </Item>
          <MedItem size={isCompleted ? 'small' : 'large'}>
            <BoldMedBodyText>{requestorName}</BoldMedBodyText>
          </MedItem>
          <SmallItem size={isCompleted ? 'small' : 'large'}>
            <BoldMedBodyText>{format(createdAt, 'MMM-dd-yyyy')}</BoldMedBodyText>
            <MedBodyText>{format(createdAt, 'hh:mm a')}</MedBodyText>
          </SmallItem>
          {isCompleted && (
            <SmallItem size={isCompleted ? 'small' : 'large'}>
              <BoldMedBodyText>{closedDate ? format(closedDate, 'MMM-dd-yyyy') : ''}</BoldMedBodyText>
              <MedBodyText>{closedDate ? format(closedDate, 'hh:mm a') : ''}</MedBodyText>
            </SmallItem>
          )}
          <SmallItem size={isCompleted ? 'small' : 'large'}>
            <BoldMedBodyText>{finalDate ? format(finalDate, 'MMM-dd-yyyy') : ''}</BoldMedBodyText>
          </SmallItem>
        </CenterFields>
        <LastItem size={isCompleted ? 'small' : 'large'}>
          <FOIStatus status={status} />
        </LastItem>
      </AllFields>
    </Wrapper>
  )
}

FOIRow.propTypes = {
  foi: PropTypes.shape({
    secondaryId: PropTypes.string.isRequired,
    applicantType: PropTypes.oneOf(['COMMERCIAL', 'PERSONAL']),
    keywords: PropTypes.array.isRequired,
    requestorName: PropTypes.string.isRequired,
    createdAt: PropTypes.instanceOf(Date).isRequired,
    closedDate: PropTypes.instanceOf(Date),
    finalDate: PropTypes.instanceOf(Date),
    status: PropTypes.oneOf(foiStatuses).isRequired
  }),
  isCompleted: PropTypes.bool
}

export default FOIRow
